import React, { useLayoutEffect, useState } from 'react';

const UserAvatar = (props) => {
    const { className, userName, userAvartar, hilightColor } = props;
    const hasAvatar = userAvartar && userAvartar.length > 0;
    const [showShortName, setShowShortName] = useState(!hasAvatar);

    useLayoutEffect(() => {
        setShowShortName(!hasAvatar);
    }, [hasAvatar]);

    const handleAvatarLoadError = () => {
        setShowShortName(true);
    };

    const getShortName = (nameInShort) => {
        const fullName = nameInShort.trim();
        let shortName = '';
        if (nameInShort) {
            shortName = fullName.split(' ').length > 1 ?
                fullName.split(' ')[0].substring(0, 1).toUpperCase() + fullName.split(' ')[1].substring(0, 1).toUpperCase() :
                fullName.substring(0, 2).toUpperCase();
        }

        return shortName;
    };

    return (
        !showShortName && hasAvatar ?
            <div className={`${className} engagement-user-avatar-fit-box`}
                style={{ borderColor: hilightColor, backgroundImage: `url(${userAvartar})` }}>
                <img onError={handleAvatarLoadError} src={userAvartar} style={{ display: 'none' }} alt="Sender avatar" />
            </div> :
            <div className="engagement-user-default-avatar" style={{ borderColor: hilightColor }}>
                <span>{getShortName(userName)}</span>
            </div>
    );
};

export default UserAvatar;
